import PageContent from '../components/PageContent';
import PageLayout from '../components/PageLayout';
import PageTitle from '../components/PageTitle';

function Music() {
  return (
    <PageLayout>
      <PageTitle>
        Music
      </PageTitle>
      <PageContent>
        Stuff about music
      </PageContent>
    </PageLayout>
  );
}

export default Music;
